import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type CalendarPrincipalEventsPathRequestParams =
  paths['/calendar/principals/{id}/calendars/{calendarId}/events']['get']['parameters']['path'];
type CalendarPrincipalEventsQueryRequestParams =
  paths['/calendar/principals/{id}/calendars/{calendarId}/events']['get']['parameters']['query'];
type CalendarPrincipalEventsResponse =
  paths['/calendar/principals/{id}/calendars/{calendarId}/events']['get']['responses']['200']['content']['application/json'];

export const getCalendarPrincipalEvents = async ({
  config,
  routeParams: { calendarId, id },
}: ConfigRouteParamsRequest<CalendarPrincipalEventsQueryRequestParams, CalendarPrincipalEventsPathRequestParams>) =>
  nodeApiClient.get<CalendarPrincipalEventsResponse, ApiClientResponse<CalendarPrincipalEventsResponse>>(
    nodeApiRoutes.calendar.principalsEvents({ calendarId, principalId: id }),
    config,
  );
